import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'

declare var window:any


export type DefinirValorAcrescimoFinanceiroInput = {
    valorAcrescimoFinanceiro: number
}

export async function definirValorAcrescimoFinanceiro(input: DefinirValorAcrescimoFinanceiroInput) {
    const orcamentoAtualizado = await microuniversoApi.Orcamento.DefinirValorAcrescimoFinanceiro(
        store.getState().orcamento.IdentificadorOrcamento,
        input.valorAcrescimoFinanceiro
    )

    const atualizarEstado = () => {
        const orcamentoLegado = window.orcamentoController.model

        orcamentoLegado.atualizar(orcamentoAtualizado, true, true)

        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
    }

    atualizarEstado()
}